import isEmptyString from '../utils/isEmptyString';

const formValidation = () => {
    const EMAIL_REG = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/; // eslint-disable-line no-useless-escape
    const NUMBER_LENGTH = 17;
    const selectors = {
        form: '.js-form',
        email: '.js-input-email',
        phone: '.js-input-phone',
        inputWrapper: '.js-input-wrapper',
        textarea: '.js-textarea',
        file: '.js-file'
    };

    const state = {
        hasError: 'has-error'
    };

    const checkInputTel = ($input, $wrapper) => {
        if ($input.val().length < NUMBER_LENGTH) {
            $wrapper.addClass(state.hasError);
        } else {
            $wrapper.removeClass(state.hasError);
        }
    };

    const checkInputEmail = ($input, $wrapper) => {
        if (EMAIL_REG.test($input.val())) {
            $wrapper.removeClass(state.hasError);
        } else {
            $wrapper.addClass(state.hasError);
        }
    };

    const checkTextarea = ($textarea, $wrapper) => {
        if (isEmptyString($textarea.val())) {
            $wrapper.addClass(state.hasError);
        } else {
            $wrapper.removeClass(state.hasError);
        }
    };

    const checkFile = ($file, $wrapper) => {
        if (isEmptyString($file.val())) {
            $wrapper.addClass(state.hasError);
        } else {
            $wrapper.removeClass(state.hasError);
        }
    };

    const validationForm = (evt) => {
        evt.preventDefault();
        const $this = $(evt.currentTarget);
        const $email = $this.find(selectors.email);
        const $emailInputWrapper = $email.closest(selectors.inputWrapper);
        const $phone = $this.find(selectors.phone);
        const $phoneInputWrapper = $phone.closest(selectors.inputWrapper);
        const $textarea = $this.find(selectors.textarea);
        const $file = $this.find(selectors.file);

        if ($phone.length) {
            checkInputTel($phone, $phoneInputWrapper);
        }

        if ($email.length) {
            checkInputEmail($email, $emailInputWrapper);
        }

        if ($textarea.length) {
            const $textareaWrapper = $textarea.closest(selectors.inputWrapper);
            checkTextarea($textarea, $textareaWrapper);
        }

        if ($file.length) {
            const $fileWrapper = $file.closest(selectors.inputWrapper);
            checkFile($file, $fileWrapper);
        }
    };

    $(selectors.form).submit(validationForm);
};

export default formValidation;
